import {
  jb_facebook_icon_css_default
} from "./chunk.4BW7HRPK.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-facebook-icon/jb-facebook-icon.ts
var JbFacebookIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.9997 8.02939C15.9997 3.59492 12.418 0 7.99984 0C3.58169 0 0 3.59492 0 8.02939C0 11.7948 2.58299 14.9546 6.0674 15.8224V10.4832H4.41783V8.02939H6.0674V6.97208C6.0674 4.2392 7.29969 2.97248 9.97292 2.97248C10.4798 2.97248 11.3543 3.07236 11.7121 3.17193V5.39607C11.5233 5.37616 11.1953 5.3662 10.7879 5.3662C9.47629 5.3662 8.96942 5.86499 8.96942 7.16157V8.02939H11.5825L11.1335 10.4832H8.96942V16C12.9306 15.5198 16 12.1347 16 8.02939H15.9997Z"
        />
      </svg>
    `;
  }
};
JbFacebookIcon.styles = [reset_css_default, jb_facebook_icon_css_default];
JbFacebookIcon = __decorateClass([
  customElement("jb-facebook-icon")
], JbFacebookIcon);

export {
  JbFacebookIcon
};
